<template>
  <!-- 视频详情图片 -->

  <div class="video-img" v-for="item in testsData" :key="item.index">
    <img :src="item.testsDescImg" alt="山河医学网卫生系列初中级职称详情页面" />
  </div>
</template>

<script>
export default {
  name: "VideoImg",
  props: {
    testsData: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    return {};
  },
};
</script>

<style lang="less" scoped>
.video-img {
  display: flex;
  margin-top: 15px;
  justify-content: center;
}
</style>
